export default function getInitials(...words: string[]) {
  return words.map((word) => word[0]).join("");
}
